module.exports = __webpack_public_path__ + "static/media/Image 14.a215a5e2.png";